<template>
  <div :class="containerClasses">
    <!-- Отладочная информация -->
    <div v-if="notifications.length > 0" style="position: fixed; top: 100px; left: 20px; background: red; color: white; padding: 10px; z-index: 10000;">
      DEBUG: {{ notifications.length }} notifications
    </div>
    
    <transition-group
      name="notification"
      tag="div"
      class="notification-list"
    >
      <notification-item
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        :show-icon="showIcon"
        :show-timestamp="showTimestamp"
        :show-progress-bar="showProgressBar"
        @dismiss="handleDismiss"
      />
    </transition-group>
  </div>
</template>

<script>
import { notificationState } from './NotificationService'
import NotificationItem from './NotificationItem.vue'

export default {
  name: 'NotificationContainer',
  components: {
    NotificationItem
  },
  props: {
    position: {
      type: String,
      default: 'top-right',
      validator: (value) => {
        return [
          'top-left',
          'top-center', 
          'top-right',
          'bottom-left',
          'bottom-center',
          'bottom-right'
        ].includes(value)
      }
    },
    maxNotifications: {
      type: Number,
      default: 5
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showTimestamp: {
      type: Boolean,
      default: false
    },
    showProgressBar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    notifications() {
      // Ограничиваем количество отображаемых уведомлений
      const notifications = notificationState.notifications.slice(-this.maxNotifications)
      console.log('Container notifications:', notifications.length, notifications)
      return notifications
    },
    containerClasses() {
      return [
        'notification-container',
        `notification-container--${this.position}`
      ]
    }
  },
  methods: {
    handleDismiss(notificationId) {
      // Удаляем уведомление из состояния
      const index = notificationState.notifications.findIndex(n => n.id === notificationId)
      if (index !== -1) {
        notificationState.notifications.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
.notification-container {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  max-width: 400px;
  width: 100%;
}

/* Позиционирование контейнера */
.notification-container--top-left {
  top: 20px;
  left: 20px;
}

.notification-container--top-center {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.notification-container--top-right {
  top: 20px;
  right: 20px;
}

.notification-container--bottom-left {
  bottom: 20px;
  left: 20px;
}

.notification-container--bottom-center {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.notification-container--bottom-right {
  bottom: 20px;
  right: 20px;
}

.notification-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Включаем pointer-events для самих уведомлений */
.notification-list >>> .notification-item {
  pointer-events: auto;
}

/* Анимации для уведомлений */
.notification-enter-active {
  transition: all 0.3s ease-out;
}

.notification-leave-active {
  transition: all 0.3s ease-in;
}

.notification-enter {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* Анимации для top позиций */
.notification-container--top-left .notification-enter,
.notification-container--top-center .notification-enter {
  transform: translateX(-100%);
}

.notification-container--top-left .notification-leave-to,
.notification-container--top-center .notification-leave-to {
  transform: translateX(-100%);
}

/* Анимации для bottom позиций */
.notification-container--bottom-left .notification-enter,
.notification-container--bottom-center .notification-enter,
.notification-container--bottom-right .notification-enter {
  transform: translateY(100%);
}

.notification-container--bottom-left .notification-leave-to,
.notification-container--bottom-center .notification-leave-to,
.notification-container--bottom-right .notification-leave-to {
  transform: translateY(100%);
}

/* Адаптивность */
@media (max-width: 768px) {
  .notification-container {
    max-width: calc(100% - 40px);
    left: 20px !important;
    right: 20px !important;
    top: 20px !important;
    transform: none !important;
  }
  
  .notification-container--bottom-left,
  .notification-container--bottom-center,
  .notification-container--bottom-right {
    top: auto !important;
    bottom: 20px !important;
  }
}
</style>